import { $Q,$Qll } from "../utils/query-selector";

/**
 * Listen the buttons for the address element and deploy the forms
 * 
 * @author Andres Briñez
 */

export const listenButtonAddresses = () => {
  const buttonAdd = $Qll(".button-add");
  const buttonEdit = $Qll(".edit-button")

  if( buttonAdd != null ) {
    buttonAdd.forEach(element => {
      element.addEventListener("click", ()=> {
        toggleEditAdrress("#AddAddress");
      })
    });
  }

  if( buttonEdit != null ) {
    buttonEdit.forEach(element => {
      element.addEventListener("click", ()=> {
        const addressId = element.getAttribute("aria-controls");
        toggleEditAdrress(`#${addressId}`);
      })
    })
  }
}

function toggleEditAdrress(address){
  const addressId = $Q(address);
  const allAddresses = $Qll(".edit-form");

  allAddresses.forEach(element => {
    element.classList.add("hidde");
  })
  
  if(addressId != null) {
    addressId.classList.toggle("hidde");
  }

}